import { createThemedUseStyles } from "theme";

export default createThemedUseStyles(theme => ({
  input: {
    fontSize: theme.typeScale.medium,
    height: 25
  }
}));
